import React from "react";
import Link from "gatsby-link";
import Imgix from "react-imgix";
import { endSlash } from "../../util/helperFunctions";

// Builds Our Events, Our Services, etc blocks that fall under 'Our Mission' block
const PageQueryAbstractPhoto = ({ page, className }) => {
  return (
    <Link
      to={endSlash(page.route)}
      className={`abstract-photo-query ${className} db flex flex-column w-100 justify-end bg-blue relative`}
    >
      {page.abstractPhoto && (
        <Imgix
          type="img"
          src={endSlash(page.abstractPhoto.url)}
          className="abstract-photo-query__photo absolute top-0 left-0 mb0 image-cover w-100 h-100"
          imgixParams={{
            "max-w": 2732,
            "fp-x": page.abstractPhotoFocalPointX,
            "fp-y": page.abstractPhotoFocalPointY,
            auto: ["compress"],
            fit: "crop",
            crop: "focalpoint"
          }}
          htmlAttributes={{
            alt: page.abstractPhotoAltText
          }}
        />
      )}
      <div className="abstract-photo-query__title bg-white flex items-center center-text justify-center">
        <h4 className="p-emphasis dark mb0 ttu">{page.title}</h4>
      </div>
    </Link>
  );
};

export default PageQueryAbstractPhoto;



// WEBPACK FOOTER //
// ./src/components/HomeHelpers/PageQueryAbstractPhoto.js